import React, { FC, ReactNode } from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { withTheme, WithTheme } from '@material-ui/core/styles';

export interface ICustomSVG {
  arrow: ReactNode;
  arrowDown: ReactNode;
  arrowUp: ReactNode;
  activity: ReactNode;
  admin: ReactNode;
  add: ReactNode;
  camera: ReactNode;
  delete: ReactNode;
  everyoneSocial: ReactNode;
  everyoneSocialSolid: ReactNode;
  facebook: ReactNode;
  flag: ReactNode;
  following: ReactNode;
  groups: ReactNode;
  home: ReactNode;
  important: ReactNode;
  lightning: ReactNode;
  link: ReactNode;
  linkedin: ReactNode;
  linkedinOutline: ReactNode;
  network: ReactNode;
  notification: ReactNode;
  pencil: ReactNode;
  people: ReactNode;
  peopleAdd: ReactNode;
  pin: ReactNode;
  readOnly: ReactNode;
  star: ReactNode;
  track: ReactNode;
  twitter: ReactNode;
  twitterOutline: ReactNode;
  xing: ReactNode;
}

interface IProps extends WithTheme, SvgIconProps {
  name: keyof ICustomSVG;
  size?: number;
  className?: string;
  viewBox?: string;
}

const ICONS: ICustomSVG = {
  activity: (
    <g fill="currentColor">
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm6.26,10.71-4.53,4.53a1,1,0,0,1-1.42-.06,1,1,0,0,1,0-1.37L15.1,13H6.46a1,1,0,0,1,0-2h8.75L12.36,8.18a1,1,0,0,1,0-1.37,1,1,0,0,1,1.37,0l4.48,4.48A1,1,0,0,1,18.26,12.71Z" />
    </g>
  ),
  add: (
    <g fill="currentColor">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </g>
  ),
  admin: (
    <g fill="currentColor">
      <path d="M14.77,16.34,12,14.82,9.23,16.3l.52-3.14L7.5,10.92l3.11-.45L12,7.63l1.39,2.87L16.5,11l-2.25,2.23ZM19.5,5.88l-6-3.48a3,3,0,0,0-3,0l-6,3.48A3,3,0,0,0,3,8.5v7a3,3,0,0,0,1.5,2.62l6,3.48a3,3,0,0,0,3,0l6-3.48A3,3,0,0,0,21,15.5v-7A3.08,3.08,0,0,0,19.5,5.88Z" />
    </g>
  ),
  arrow: (
    <g fill="currentColor">
      <path d="M20.66,11.2,15.91,6.3a1,1,0,0,0-1.46,0,1.11,1.11,0,0,0,0,1.5l3,3.11H4.06a1.1,1.1,0,0,0,0,2.19h13.3l-3,3a1.11,1.11,0,0,0,0,1.5,1,1,0,0,0,1.51.05l4.8-4.95A1.12,1.12,0,0,0,20.66,11.2Z" />
    </g>
  ),
  arrowDown: (
    <g fill="currentColor">
      <path d="M15.58,2.82v9.25H18.2a1.8,1.8,0,0,1,1.62,1A1.85,1.85,0,0,1,19.61,15v0L12.68,22.7A.89.89,0,0,1,12,23a.91.91,0,0,1-.67-.3L4.4,15A1.84,1.84,0,0,1,4,13.89a1.76,1.76,0,0,1,.18-.79,1.78,1.78,0,0,1,1.58-1H8.39V2.82A1.81,1.81,0,0,1,10.18,1h3.6A1.82,1.82,0,0,1,15.58,2.82Z" />
    </g>
  ),
  arrowUp: (
    <g fill="currentColor">
      <path d="M15.58,21.18V11.93H18.2a1.8,1.8,0,0,0,1.62-1A1.85,1.85,0,0,0,19.61,9v0L12.68,1.3A.89.89,0,0,0,12,1a.91.91,0,0,0-.67.3L4.4,9A1.84,1.84,0,0,0,4,10.11a1.76,1.76,0,0,0,.18.79,1.78,1.78,0,0,0,1.58,1H8.39v9.25A1.81,1.81,0,0,0,10.18,23h3.6A1.82,1.82,0,0,0,15.58,21.18Z" />
    </g>
  ),
  camera: (
    <g fill="currentColor">
      <path d="M20,4.00001118 L17.6175,4.00001118 L16.4475,1.65751249 C15.9419215,0.639271464 14.9018439,-0.00338563844 13.765,1.34173613e-05 L10.235,1.34173613e-05 C9.09815612,-0.00338563844 8.0580785,0.639271464 7.5525,1.65751249 L6.3825,4.00001118 L4,4.00001118 C1.790861,4.00001118 2.22044605e-16,5.79087118 0,8.00000894 L0,20.0000022 C2.22044605e-16,22.20914 1.790861,24 4,24 L20,24 C22.209139,24 24,22.20914 24,20.0000022 L24,8.00000894 C24,5.79087118 22.209139,4.00001118 20,4.00001118 Z M22,20.0000022 C22,21.1045711 21.1045695,22.0000011 20,22.0000011 L4,22.0000011 C2.8954305,22.0000011 2,21.1045711 2,20.0000022 L2,8.00000894 C2,6.89544006 2.8954305,6.00001006 4,6.00001006 L7,6.00001006 C7.37891461,6.00028134 7.72543576,5.78636757 7.895,5.44751037 L9.3425,2.55251199 C9.5116609,2.21445955 9.85698607,2.00068695 10.235,2.0000123 L13.765,2.0000123 C14.1430139,2.00068695 14.4883391,2.21445955 14.6575,2.55251199 L16.105,5.44751037 C16.2745642,5.78636757 16.6210854,6.00028134 17,6.00001006 L20,6.00001006 C21.1045695,6.00001006 22,6.89544006 22,8.00000894 L22,20.0000022 Z" />
      <circle cx="4.898" cy="9.306" r="1" />
      <path d="M11.755102,8.81632653 C9.05003388,8.81632653 6.85714286,11.0092176 6.85714286,13.7142857 C6.85714286,16.4193539 9.05003388,18.6122449 11.755102,18.6122449 C14.4601702,18.6122449 16.6530612,16.4193539 16.6530612,13.7142857 C16.6530612,12.4152662 16.1370277,11.1694511 15.2184822,10.2509056 C14.2999367,9.33236003 13.0541216,8.81632653 11.755102,8.81632653 Z M11.755102,16.6530612 C10.1320611,16.6530612 8.81632653,15.3373266 8.81632653,13.7142857 C8.81632653,12.0912448 10.1320611,10.7755102 11.755102,10.7755102 C13.3781429,10.7755102 14.6938776,12.0912448 14.6938776,13.7142857 C14.6938776,15.3373266 13.3781429,16.6530612 11.755102,16.6530612 Z" />
    </g>
  ),
  delete: (
    <g fill="currentColor">
      <path d="M6,19a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V7H6ZM19,4H15.5l-1-1h-5l-1,1H5V6H19Z" />
    </g>
  ),
  everyoneSocial: (
    <g transform="translate(1.000000, 3.000000)">
      <path
        fill="#F9A81A"
        d="M11.8,1.4v6.3c0,0.2,0.2,0.2,0.3,0.1c0.4-0.5,1.5-2.3,3.8-2.3c2.2,0,4.1-1.7,4.3-3.9C20.4-0.9,18.4-3,15.9-3C13.6-3,11.8-1,11.8,1.4"
      />
      <path
        fill="#E82164"
        d="M9.9,8.5v6.9c0,0.2-0.2,0.3-0.4,0.1c-0.6-0.6-2-1.6-5-1.7c-2.8,0-5.3-2.1-5.5-5c-0.3-3.3,2.3-6.1,5.5-6.1C7.5,2.9,9.9,5.5,9.9,8.5"
      />
      <path
        fill="#6FBE44"
        d="M11.8,13.6v7.1c0,0.2,0.2,0.3,0.4,0.1c0.6-0.7,2-1.7,5.1-1.7c2.9,0,5.4-2.2,5.7-5.2c0.3-3.4-2.3-6.3-5.6-6.2C14.2,7.8,11.8,10.5,11.8,13.6"
      />
    </g>
  ),
  everyoneSocialSolid: (
    <g fill="currentColor" transform="translate(1.000000, 3.000000)">
      <path d="M11.8,1.4v6.3c0,0.2,0.2,0.2,0.3,0.1c0.4-0.5,1.5-2.3,3.8-2.3c2.2,0,4.1-1.7,4.3-3.9C20.4-0.9,18.4-3,15.9-3C13.6-3,11.8-1,11.8,1.4" />
      <path d="M9.9,8.5v6.9c0,0.2-0.2,0.3-0.4,0.1c-0.6-0.6-2-1.6-5-1.7c-2.8,0-5.3-2.1-5.5-5c-0.3-3.3,2.3-6.1,5.5-6.1C7.5,2.9,9.9,5.5,9.9,8.5" />
      <path d="M11.8,13.6v7.1c0,0.2,0.2,0.3,0.4,0.1c0.6-0.7,2-1.7,5.1-1.7c2.9,0,5.4-2.2,5.7-5.2c0.3-3.4-2.3-6.3-5.6-6.2C14.2,7.8,11.8,10.5,11.8,13.6" />
    </g>
  ),
  facebook: (
    <g fill="currentColor">
      <path d="M19,4V7H17a.94.94,0,0,0-1,1v2h3v3H16v7H13V13H11V10h2V7.5A3.54,3.54,0,0,1,16.5,4Zm1-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Z" />
    </g>
  ),
  flag: (
    <g fill="currentColor">
      <path d="M8.76,21.05a.43.43,0,0,1-.54-.29L3,4a.43.43,0,1,1,.83-.25L9.05,20.51A.43.43,0,0,1,8.76,21.05Zm9.13-16.9c-.69.2-2.29.65-5.35-1.09C10.3,1.89,7.41.9,4.65,3.28A1.4,1.4,0,0,0,3,2.56a1.37,1.37,0,0,0-.91,1.71L7.33,21a1.36,1.36,0,1,0,2.6-.79L8,14.05c2.05-1.8,4.32-2,6.94-.44a8,8,0,0,0,4,1.22,4.16,4.16,0,0,0,2.3-.59,1.87,1.87,0,0,0,.58-2.12c-.6-1.94-2.08-6.74-2.19-7.13S19.11,3.82,17.89,4.15Z" />
    </g>
  ),
  following: (
    <g fill="currentColor">
      <path d="M5.4,13.27a4.37,4.37,0,1,0,4.36,4.37A4.37,4.37,0,0,0,5.4,13.27Zm0,7.23a2.87,2.87,0,1,1,2.86-2.86A2.86,2.86,0,0,1,5.4,20.5Z" />
      <path d="M18.6,13.27A4.37,4.37,0,1,0,23,17.64,4.37,4.37,0,0,0,18.6,13.27Zm0,7.23a2.87,2.87,0,1,1,2.86-2.86A2.86,2.86,0,0,1,18.6,20.5Z" />
      <path d="M12,9.84A4.36,4.36,0,1,0,7.64,5.48,4.36,4.36,0,0,0,12,9.84Zm0-7.22A2.86,2.86,0,1,1,9.14,5.48,2.86,2.86,0,0,1,12,2.62Z" />
      <path d="M12,11.12a2.17,2.17,0,0,0-2.09,2.1A2.17,2.17,0,0,0,12,15.32a2.17,2.17,0,0,0,2.09-2.1A2.17,2.17,0,0,0,12,11.12Z" />
    </g>
  ),
  groups: (
    <g fill="currentColor">
      <path d="M18.5,15a3.51,3.51,0,0,0-2.39.95l-3.57-2.06A5.42,5.42,0,0,0,12.89,12a5.61,5.61,0,0,0-.34-1.89l3.56-2.06A3.5,3.5,0,1,0,15,5.5a3.18,3.18,0,0,0,.11.82l-3.6,2.07a5.43,5.43,0,1,0,0,7.21l3.6,2.08a3.18,3.18,0,0,0-.11.82A3.5,3.5,0,1,0,18.5,15Zm0-11A1.5,1.5,0,1,1,17,5.5,1.5,1.5,0,0,1,18.5,4Zm0,16A1.5,1.5,0,1,1,20,18.5,1.5,1.5,0,0,1,18.5,20Z" />
    </g>
  ),
  home: (
    <g fill="currentColor">
      <path d="M12.16,2H12a9,9,0,0,0-8.92,8.88v10.4a.71.71,0,0,0,.5.67.86.86,0,0,0,.27.05.76.76,0,0,0,.56-.24c.84-.87,2.92-2.34,7.5-2.38A9,9,0,0,0,21,11.52a8.55,8.55,0,0,0-2.46-6.83A8.94,8.94,0,0,0,12.16,2Z" />
    </g>
  ),
  important: (
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M21,12.39a1,1,0,0,1-.23,1.1s-1.9,1.29-5.31-.68c-2.83-1.63-5.42-1.52-7.69.29L5,4.24c2.42-2.32,4.86-1.55,7.13-.36,3.39,1.92,5.09,1.44,5.9,1.2l.14,0c.52-.14.56,0,.62.2C18.86,5.64,20.35,10.45,21,12.39ZM8.76,21.05a.43.43,0,0,1-.54-.29L3,4a.43.43,0,1,1,.83-.25L9.05,20.51A.43.43,0,0,1,8.76,21.05Zm9.13-16.9c-.69.2-2.29.65-5.35-1.09C10.3,1.89,7.41.9,4.65,3.28A1.4,1.4,0,0,0,3,2.56a1.37,1.37,0,0,0-.91,1.71L7.33,21a1.36,1.36,0,1,0,2.6-.79L8,14.05c2.05-1.8,4.32-2,6.94-.44a8,8,0,0,0,4,1.22,4.16,4.16,0,0,0,2.3-.59,1.87,1.87,0,0,0,.58-2.12c-.6-1.94-2.08-6.74-2.19-7.13S19.11,3.82,17.89,4.15Z"
      />
    </g>
  ),
  lightning: (
    <g fill="currentColor">
      <path d="M11.5,2.5a.42.42,0,0,0-.33.23L6.65,11.37a.43.43,0,0,0,.18.58A.42.42,0,0,0,7,12h3.49L8,21a.44.44,0,0,0,.31.53.45.45,0,0,0,.46-.16s6.34-8.67,8.55-11.2A.44.44,0,0,0,17,9.41h-2.5l2.89-6.3a.43.43,0,0,0-.22-.57.33.33,0,0,0-.17,0H11.5Z" />
    </g>
  ),
  link: (
    <g fill="currentColor">
      <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" />
    </g>
  ),
  linkedin: (
    <g fill="currentColor">
      <path d="M19,19H16V13.7a1.5,1.5,0,0,0-3,0V19H10V10h3v1.2a3.23,3.23,0,0,1,2.5-1.4A3.54,3.54,0,0,1,19,13.3ZM6.5,8.3A1.8,1.8,0,1,1,8.3,6.5,1.79,1.79,0,0,1,6.5,8.3ZM8,19H5V10H8ZM20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Z" />
    </g>
  ),
  linkedinOutline: (
    <g fill="currentColor">
      <path d="M5.456 6.909v12.456H1.17V6.91h4.286zm.283-3.853c0 1.196-.931 2.153-2.426 2.153h-.027c-1.44 0-2.37-.957-2.37-2.153 0-1.222.959-2.152 2.425-2.152 1.467 0 2.37.93 2.398 2.152zm15.177 9.167v7.142h-4.287v-6.664c0-1.674-.62-2.816-2.172-2.816-1.184 0-1.89.77-2.2 1.514-.113.266-.14.638-.14 1.01v6.957H7.828s.057-11.288 0-12.457h4.287v1.765c.57-.848 1.588-2.058 3.864-2.058 2.821 0 4.936 1.781 4.936 5.607z" />
    </g>
  ),
  network: (
    <g fill="currentColor">
      <path d="M18,19.5a2,2,0,1,1,2-2A2,2,0,0,1,18,19.5Zm0-6a4,4,0,1,0,4,4A4,4,0,0,0,18,13.5Zm-6-1.9a1.9,1.9,0,0,0,0,3.8,1.9,1.9,0,0,0,0-3.8ZM6,19.5a2,2,0,1,1,2-2A2,2,0,0,1,6,19.5Zm0-6a4,4,0,1,0,4,4A4,4,0,0,0,6,13.5Zm6-9a2,2,0,1,1-2,2A2,2,0,0,1,12,4.5Zm0,6a4,4,0,1,0-4-4A4,4,0,0,0,12,10.5Z" />
    </g>
  ),
  notification: (
    <g fill="currentColor">
      <path d="M18,15.75v-5c0-3.07-1.64-5.64-4.5-6.32V3.75a1.5,1.5,0,0,0-3,0v.68C7.63,5.11,6,7.67,6,10.75v5l-2,2v1H20v-1Zm-6,6a2,2,0,0,0,2-2H10A2,2,0,0,0,12,21.75Z" />
    </g>
  ),
  pencil: (
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.7,19.3c0.2-0.4,1-2.7,1.4-3.6L8.3,18C7.3,18.4,5,19.2,4.7,19.3z M19.6,7.8c0.5-0.5,0.5-1.3,0-1.8L18,4.4c-0.5-0.5-1.3-0.5-1.8,0L5.7,14.9C5.5,15.1,4,19.1,4,19.2c-0.1,0.4,0.3,0.9,0.8,0.8c0,0,4.1-1.5,4.2-1.6L19.6,7.8z"
      />
    </g>
  ),
  people: (
    <g fill="currentColor">
      <path d="M16,13a3.75,3.75,0,0,0-1,.1,4.12,4.12,0,0,1,2,3.4V19h6V16.5C23,14.2,18.3,13,16,13ZM8,13c-2.3,0-7,1.2-7,3.5V19H15V16.5C15,14.2,10.3,13,8,13Zm0-2a3,3,0,0,0,3-3A3,3,0,0,0,8,5,3,3,0,0,0,5,8,3,3,0,0,0,8,11Zm8,0a3,3,0,0,0,3-3,3,3,0,0,0-6,0A3,3,0,0,0,16,11Z" />
    </g>
  ),
  peopleAdd: (
    <g fill="currentColor">
      <path d="M8 11H5V8H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.7 0 3-1.3 3-3s-1.3-3-3-3c-.3 0-.6.1-.9.1.6.9.9 1.8.9 2.9 0 1.1-.3 2-.9 2.9.3 0 .6.1.9.1zm-5 0c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.3 3 3 3zm6.6 2.2c.8.7 1.4 1.7 1.4 2.8v2h3v-2c0-1.5-2.4-2.5-4.4-2.8zM13 14c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z" />
    </g>
  ),
  pin: (
    <g fill="currentColor">
      <path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2z" />
    </g>
  ),
  readOnly: (
    <g fill="currentColor">
      <path d="M6.58,10h.57l.72,1.21h.65L7.73,9.94A.9.9,0,0,0,8.5,9,1,1,0,0,0,7.44,8H6v3.23h.56Zm0-1.52h.78a.51.51,0,1,1,0,1H6.58Z" />
      <polygon points="11.28 10.71 9.63 10.71 9.63 9.81 11.24 9.81 11.24 9.31 9.63 9.31 9.63 8.48 11.28 8.48 11.28 7.98 9.06 7.98 9.06 11.21 11.28 11.21 11.28 10.71" />
      <path d="M12.38,10.59h1.53l.24.62h.62L13.5,8h-.71l-1.27,3.23h.62Zm.76-2.13.61,1.63H12.54Z" />
      <path d="M16.32,8h-1.2v3.23h1.2a1.62,1.62,0,1,0,0-3.23Zm0,2.73h-.63V8.48h.63A1,1,0,0,1,17.44,9.6,1.06,1.06,0,0,1,16.32,10.71Z" />
      <path d="M7.64,12.68a1.67,1.67,0,0,0,0,3.34,1.6,1.6,0,0,0,1.65-1.67A1.6,1.6,0,0,0,7.64,12.68Zm0,2.84a1.08,1.08,0,0,1-1.08-1.17,1.08,1.08,0,1,1,2.15,0A1.08,1.08,0,0,1,7.64,15.52Z" />
      <polygon points="12.07 15.02 10.42 12.73 9.84 12.73 9.84 15.97 10.4 15.97 10.4 13.61 12.09 15.97 12.64 15.97 12.64 12.73 12.07 12.73 12.07 15.02" />
      <polygon points="13.89 12.73 13.33 12.73 13.33 15.97 15.32 15.97 15.32 15.47 13.89 15.47 13.89 12.73" />
      <polygon points="16.43 14.12 15.54 12.73 14.89 12.73 16.14 14.62 16.14 15.97 16.71 15.97 16.71 14.62 17.96 12.73 17.31 12.73 16.43 14.12" />
      <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,19a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z" />
    </g>
  ),
  star: (
    <g fill="currentColor">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </g>
  ),
  track: (
    <g fill="currentColor">
      <path d="M23,8a2,2,0,0,1-2,2,1.7,1.7,0,0,1-.51-.07l-3.56,3.55A1.77,1.77,0,0,1,17,14a2,2,0,0,1-4,0,1.77,1.77,0,0,1,.07-.52l-2.55-2.55a2,2,0,0,1-1,0L4.93,15.49A1.7,1.7,0,0,1,5,16a2,2,0,1,1-2-2,1.7,1.7,0,0,1,.51.07L8.07,9.52A1.77,1.77,0,0,1,8,9a2,2,0,0,1,4,0,1.77,1.77,0,0,1-.07.52l2.55,2.55a2,2,0,0,1,1,0l3.55-3.56A1.7,1.7,0,0,1,19,8a2,2,0,0,1,4,0Z" />
    </g>
  ),
  twitter: (
    <g fill="currentColor">
      <path d="M17.7,9.3c-.1,4.6-3,7.8-7.4,8A7.28,7.28,0,0,1,6,16.1,5.31,5.31,0,0,0,9.9,15a2.7,2.7,0,0,1-2.5-1.9,4,4,0,0,0,1.1,0,2.72,2.72,0,0,1-2.1-2.7,2,2,0,0,0,1.1.3,3,3,0,0,1-.8-3.6,7.92,7.92,0,0,0,5.5,2.8c-.7-2.8,3.1-4.3,4.6-2.4a6.74,6.74,0,0,0,1.7-.6,2.83,2.83,0,0,1-1.1,1.5A5.73,5.73,0,0,0,18.8,8C18.7,8.5,18.2,8.9,17.7,9.3ZM20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Z" />
    </g>
  ),
  twitterOutline: (
    <g fill="currentColor">
      <path d="M10.615 5.314l.044.72-.723-.088c-2.63-.338-4.928-1.486-6.879-3.413l-.953-.956-.246.706c-.52 1.574-.188 3.237.896 4.355.578.618.448.706-.55.338-.346-.117-.65-.206-.678-.162-.102.103.245 1.442.52 1.972.376.735 1.141 1.456 1.98 1.883l.708.338-.838.015c-.81 0-.839.015-.752.324.29.956 1.43 1.971 2.702 2.412l.896.31-.78.47a8.085 8.085 0 0 1-3.873 1.089c-.65.014-1.185.073-1.185.117 0 .148 1.763.971 2.79 1.295 3.077.956 6.733.544 9.48-1.089 1.95-1.162 3.9-3.472 4.811-5.708.492-1.191.983-3.369.983-4.413 0-.677.043-.765.853-1.574.477-.471.925-.986 1.011-1.133.145-.28.13-.28-.607-.03-1.228.442-1.401.383-.795-.28.448-.47.983-1.323.983-1.573 0-.045-.217.029-.462.161-.26.148-.838.368-1.272.5l-.78.25-.708-.485c-.39-.265-.94-.559-1.229-.647-.737-.206-1.864-.177-2.529.059-1.806.662-2.948 2.368-2.818 4.237z" />
    </g>
  ),
  xing: (
    <g fill="currentColor">
      <path d="M27.41,3.07,18.55,18.65v0l5.64,10.26a.56.56,0,0,1-.52.87h-4a1.23,1.23,0,0,1-1.11-.75L12.86,18.67q.32-.54,8.91-15.72a1.23,1.23,0,0,1,1.08-.75h4a.56.56,0,0,1,.52.25A.58.58,0,0,1,27.41,3.07ZM11.31,8.35,13.89,13l-4,7.46a1.23,1.23,0,0,1-1,.75H5.07A.51.51,0,0,1,4.58,21a.57.57,0,0,1,0-.59l4-7.32s0,0,0,0L6,8.47a.54.54,0,0,1,0-.61.53.53,0,0,1,.5-.24h3.76A1.19,1.19,0,0,1,11.31,8.35Z" />
    </g>
  ),
};

const CustomSVG: FC<IProps> = ({ name, size, className, viewBox, theme, ...props }) => (
  <SvgIcon
    fontSize="inherit"
    className={className}
    style={{ fontSize: theme.typography.pxToRem(size) }}
    viewBox={viewBox}
    {...props}>
    {ICONS[name]}
  </SvgIcon>
);

CustomSVG.defaultProps = {
  size: 24,
  className: '',
  viewBox: '0 0 24 24',
};

export default withTheme(CustomSVG);
